/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOrganizationRequestLegalInfo
 */
export interface CreateOrganizationRequestLegalInfo {
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequestLegalInfo
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequestLegalInfo
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequestLegalInfo
     */
    taxId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequestLegalInfo
     */
    legalEntityId: string;
}

/**
 * Check if a given object implements the CreateOrganizationRequestLegalInfo interface.
 */
export function instanceOfCreateOrganizationRequestLegalInfo(value: object): value is CreateOrganizationRequestLegalInfo {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('taxId' in value) || value['taxId'] === undefined) return false;
    if (!('legalEntityId' in value) || value['legalEntityId'] === undefined) return false;
    return true;
}

export function CreateOrganizationRequestLegalInfoFromJSON(json: any): CreateOrganizationRequestLegalInfo {
    return CreateOrganizationRequestLegalInfoFromJSONTyped(json, false);
}

export function CreateOrganizationRequestLegalInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrganizationRequestLegalInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'address': json['address'],
        'taxId': json['taxId'],
        'legalEntityId': json['legalEntityId'],
    };
}

export function CreateOrganizationRequestLegalInfoToJSON(json: any): CreateOrganizationRequestLegalInfo {
    return CreateOrganizationRequestLegalInfoToJSONTyped(json, false);
}

export function CreateOrganizationRequestLegalInfoToJSONTyped(value?: CreateOrganizationRequestLegalInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'address': value['address'],
        'taxId': value['taxId'],
        'legalEntityId': value['legalEntityId'],
    };
}

